const GLOBAL_BLACKLIST_MARKER_PERMANENT = 'permanent'
exports.GLOBAL_BLACKLIST_MARKER_PERMANENT = GLOBAL_BLACKLIST_MARKER_PERMANENT
